import { createSlice } from '@reduxjs/toolkit'
import { CompanyCard } from '@leadgen/models/client'
import authActions from '../auth/actions'
import actions from './actions'

export interface CompanyCardsState {
  companyCards: CompanyCard[]
  companyCardIds: Record<string, boolean>
  error?: string
  status: 'initial' | 'idle' | 'loading' | 'failed'
}

export const initialState: CompanyCardsState = {
  companyCards: [],
  companyCardIds: {},
  status: 'initial',
}

export const companyCardsSlice = createSlice({
  name: 'companyCards',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(authActions.loggedOut.type, () => {
        return initialState
      })
      .addCase(actions.loadCompanyCards.pending, state => {
        state.status = 'loading'
      })
      .addCase(actions.loadCompanyCards.fulfilled, (state, action) => {
        state.status = 'idle'
        state.companyCards = action.payload.data
        state.companyCardIds = action.payload.data.reduce(
          (memo, next) => {
            memo[next.id] = true
            return memo
          },
          <Record<string, boolean>>{},
        )
        state.error = undefined
      })
      .addCase(actions.loadCompanyCards.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(actions.addCompanyCard, (state, action) => {
        if (state.companyCardIds[action.payload.id]) {
          return
        }
        state.companyCardIds[action.payload.id] = true
        state.companyCards.push(action.payload)
      })
      .addCase(actions.updateCompanyCard, (state, action) => {
        for (let i = 0, length = state.companyCards.length; i < length; i++) {
          const companyCard = state.companyCards[i]
          if (companyCard.id === action.payload.id) {
            state.companyCards[i] = action.payload
            break
          }
        }
      })
      .addCase(actions.deleteCompanyCard, (state, action) => {
        const index = state.companyCards.findIndex(
          companyCard => companyCard.id === action.payload.companyCardId,
        )
        if (index >= 0) {
          state.companyCards.splice(index, 1)
          delete state.companyCardIds[action.payload.companyCardId]
        }
      })
  },
})

export default companyCardsSlice
